// Libraries
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

// Components
import Text from "@Components/Text";
import Clock from "@Components/Clock";

// Hooks
import useClock from "@Hooks/useClock";

// Utils
import { getClockLabel } from "@Utils/formats";

// Styles
import styles from "./styles.module.css";

const ClockDisplays = ({ messageTimestamp, createdDate, closeDate = 0, isHistoric = false, state }) => {
	const clockTime = useClock(messageTimestamp, isHistoric ? 0 : null);
	const totalTime = isHistoric ? useClock(createdDate, closeDate) : useClock(createdDate);

	return (
		<div className={styles.clockContainer}>
			{!isHistoric && <Clock time={clockTime} />}
			<div className={styles.textRow}>
				<Text className={`${styles.tag} ${styles[String(state).toLowerCase()]}`}>{state}</Text>
				<Text className={styles.durationText}>{moment(createdDate).format("DD/MM/YYYY hh:mm A")}</Text>
				<Text className={styles.durationText}>{`Total: ${getClockLabel(totalTime)}`}</Text>
			</div>
		</div>
	);
};

ClockDisplays.propTypes = {
	messageTimestamp: PropTypes.number.isRequired,
	createdDate: PropTypes.string.isRequired,
	closeDate: PropTypes.string,
	isHistoric: PropTypes.bool,
	state: PropTypes.string,
};

export default ClockDisplays;
